'use client';

import React from 'react';
import type { ElementType } from 'react';
import type { SeparatorProps as AriaSeparatorProps } from 'react-aria-components';
import { Separator as AriaSeparator } from 'react-aria-components';
import { cx } from '@milanote/roma/utils/cx';
import type { PolymorphicProps } from '../../../types/polymorphic';

const COMMAND_MENU_SEPARATOR_DISPLAY_NAME = 'RomaCommandMenuSeparator';

type CommandMenuSeparatorOwnProps = {
    className?: string;
};

type CommandMenuSeparatorBaseComponentProps<T extends ElementType> = PolymorphicProps<CommandMenuSeparatorOwnProps, T>;

export type CommandMenuSeparatorBaseProps = PolymorphicProps<CommandMenuSeparatorOwnProps>;

export const CommandMenuSeparatorBase = <T extends ElementType = 'div'>(
    props: CommandMenuSeparatorBaseComponentProps<T>,
) => {
    const { as, className, ...restProps } = props;
    const Component = as ?? 'div';

    return (
        <Component
            {...restProps}
            className={cx(
                COMMAND_MENU_SEPARATOR_DISPLAY_NAME,
                '-mx-1.5 my-xs block border-0 border-t border-toolbar_alpha',
                className,
            )}
        />
    );
};

export type CommandMenuSeparatorProps = Omit<AriaSeparatorProps, 'className' | 'orientation'> & {
    className?: string;
};

export const CommandMenuSeparator: React.FC<CommandMenuSeparatorProps> = ({ className, ...props }) => (
    <CommandMenuSeparatorBase as={AriaSeparator} {...props} orientation="horizontal" className={className} />
);

CommandMenuSeparatorBase.displayName = COMMAND_MENU_SEPARATOR_DISPLAY_NAME;
CommandMenuSeparator.displayName = COMMAND_MENU_SEPARATOR_DISPLAY_NAME;
